import { instantsInterceptor, } from '@/api/index';

function getQnaList(form) {
    return instantsInterceptor.post('/qna/list', form);
}

function getQna(boardId) {
    return instantsInterceptor.get('/service/qna/view/' + boardId);
}

function getAnswerFiles(boardId) {
    return instantsInterceptor.get('/service/qna/answer/' + boardId);
}

function insertQna(qna) {
    return instantsInterceptor.post('/service/qna/save', qna);
}

function updateAnswerSeq(answers) {
    return instantsInterceptor.post('/service/qna/update/seq', answers);
}

function deleteQna(qna) {
    return instantsInterceptor.post('/service/qna/delete', qna);
}

function deleteQnaAnswer(qna) {
    return instantsInterceptor.post('/service/qna/deleteQnaAnswer', qna);
}

function getUserQnaClsList() {
    return instantsInterceptor.get('/qna/clsList');
}

function getQnaMgmtList(qna) {
    return instantsInterceptor.post('/mgmt/qna/list', qna);
}

function saveQnaAnswer(answer) {
    return instantsInterceptor.post('/mgmt/qna/saveAnswer', answer);
}

function deleteMgmtQnaAnswer(answer) {
    return instantsInterceptor.post('/mgmt/qna/deleteAnswer', answer);
}

function getQnaClsList() {
    return instantsInterceptor.get('/mgmt/qna/cls/list');
}

function saveQnaCls(qnaCls) {
    return instantsInterceptor.post('/mgmt/qna/cls/save', qnaCls);
}

function deleteQnaCls(classId) {
    return instantsInterceptor.post('/mgmt/qna/cls/delete', { classId: classId });
}

function getQnaClsMember() {
    return instantsInterceptor.get('/mgmt/qna/cls/member/list');
}


function saveQnaClsMember(newMem) {
    return instantsInterceptor.post('/mgmt/qna/cls/member/save', newMem);
}

function saveNewQaClsSort(qaCls) {
    return instantsInterceptor.post('/mgmt/qna/cls/sort/edit', qaCls);
}

function getQnaClsDetail(classId) {
    return instantsInterceptor.post('/mgmt/qna/cls/detail', { classId: classId });
}

function deleteMgmtQna(qna) {
    return instantsInterceptor.post('/mgmt/qna/delete', qna);
}

export {
    getQnaList,
    getQna,
    insertQna,
    saveQnaAnswer,
    getAnswerFiles,
    deleteQna,
    deleteMgmtQnaAnswer,
    saveQnaCls,
    getQnaClsList,
    deleteQnaCls,
    getUserQnaClsList,
    saveNewQaClsSort,
    getQnaMgmtList,
    getQnaClsMember,
    saveQnaClsMember,
    getQnaClsDetail,
    deleteMgmtQna,
    updateAnswerSeq,
    deleteQnaAnswer
};